
import Vue from 'vue'
import { VImg } from 'vuetify/lib'

export default Vue.extend({
  name: 'JcdcImg',
  components: {
    VImg,
  },
  props: {
    src: {
      type: String,
      required: true,
    },
  },
  computed: {
    imgFile(): string {
      if (this.src.includes('http')) {
        return this.src
      }
      return require(`@/assets/images/${this.src}`)
    },
  },
})
